<template>
    <div>
        <div class="alert" role="alert"
             v-if="is_open"
             v-bind:class="[alertTypeClass]">

            <button type="button" class="close" aria-label="Close"
                    @click="closeAlert">

                <span aria-hidden="true">&times;</span>
            </button>

            <h4 v-if="title" v-text="title"></h4>

            <p v-if="body" v-text="body"></p>

            <div class="btn-group">
                <a class="btn"
                   v-for="button in buttons"
                   v-bind:class="[buttonTypeClass]"
                   v-bind:href="getButtonHref(button)"
                   v-bind:target="getButtonTarget(button)"
                   v-on:click="getButtonClickListener(button, $event)"
                   v-text="button.title"></a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "alert",
        props: ['alert'],
        created() {
            this.is_open = this.alert.is_open;
            this.type = this.alert.type;
            this.title = this.alert.title;
            this.body = this.alert.body;
        },
        data() {
            return {
                is_open: false,
                type: "danger",
                title: "알려드립니다.",
                body: "",
                buttons: []
            }
        },
        watch: {
            alert: {
                handler: function(new_alert, old_alert) {
                    this.is_open = new_alert.is_open;
                    this.type = new_alert.type;
                    this.title = new_alert.title;
                    this.body = new_alert.body;

                    this.$forceUpdate();
                },
                deep: true
            }
        },
        computed: {
            alertTypeClass() {
                return 'alert' + '-' + this.type;
            },
            buttonTypeClass() {
                return 'btn' + '-' + this.type;
            },
        },
        methods: {
            closeAlert() {
                this.alert.is_open = false;
                this.is_open = false;
            },
            getButtonHref(button) {
                if (typeof button.href === 'string' && button.href !== '') {
                    return button.href;
                }
                return '#';
            },
            getButtonClickListener(button, event) {
                if (typeof button.href === 'function') {
                    button.href();
                    event.preventDefault();
                }

                return false;
            },
            getButtonTarget(button) {
                if (typeof button.href === 'string' && button.href !== '') {
                    return button.target;
                }

                return false;
            }
        }
    }
</script>

<style lang="scss" scoped>

.alert {
    h4 {
        font-weight: bold;
    }
    .btn-group {
        margin-top: 1em;

        .btn {
            margin-right: 0.5em;

            &:last-child {
                margin-right: 0;
            }
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/Alert.vue